import { Table, Tag, type TableColumnsType } from 'antd';
import type { RateLineImportCommitRow, RateLineImportRowOutcome } from '../../../rate-cards.api';
import { ROW_STATUS_COLORS, ROW_STATUS_LABELS } from '../policies/rate-line-import-row-status';

const OUTCOME_LABELS: Record<RateLineImportRowOutcome, string> = { created: 'Draft proposal created', skipped: 'Skipped', error: 'Failed' };
const OUTCOME_COLORS: Record<RateLineImportRowOutcome, string> = { created: 'success', skipped: 'default', error: 'error' };

function ErrorsCell({ row }: { row: RateLineImportCommitRow }) {
  if (!row.errors?.length) return null;
  return (
    <ul className="text-xs text-error">
      {row.errors.map((error, index) => (
        <li key={index}>{error.message}</li>
      ))}
    </ul>
  );
}

const COLUMNS: TableColumnsType<RateLineImportCommitRow> = [
  { title: 'Row', dataIndex: 'rowNumber', key: 'rowNumber', width: 64 },
  { title: 'Status', key: 'status', render: (_, row) => <Tag color={ROW_STATUS_COLORS[row.status]}>{ROW_STATUS_LABELS[row.status]}</Tag> },
  { title: 'Outcome', key: 'outcome', render: (_, row) => <Tag color={OUTCOME_COLORS[row.outcome]}>{OUTCOME_LABELS[row.outcome]}</Tag> },
  { title: 'Detail', key: 'detail', render: (_, row) => <ErrorsCell row={row} /> },
];

/** What committing actually did, row by row: a draft proposal per new/changed row, nothing for unchanged or invalid, and a row that went stale between preview and commit reported here rather than failing the rest of the batch. */
export function RateLineImportCommitResults({ rows }: { rows: RateLineImportCommitRow[] }) {
  return <Table rowKey="rowNumber" dataSource={rows} columns={COLUMNS} pagination={false} scroll={{ x: 'max-content' }} size="small" />;
}
